import {ClientMaintenanceService} from '../../libs/ui/src/index';

import {client} from '../apiService';

const _ClientMaintenanceService = new ClientMaintenanceService({client});
export {_ClientMaintenanceService as ClientMaintenanceService};
